// extracted by mini-css-extract-plugin
export var closeButton = "_38-3";
export var header = "_38-0";
export var link = "_38-1";
export var retryButton = "_38-2";